import { assert } from "@/common/assert";
import { FhtLeancloudCustomMessageType } from "@/common/types";
import RichCustomChatMessageDto from "@/models/messages/RichCustomChatMessageDto";
export var SAVE_MESSAGE_DRAFT = "MESSAGES/SAVE_MESSAGE_DRAFT";
export var STORE_SENT_MESSAGE = "MESSAGES/STORE_SENT_MESSAGE";
export var RECEIVE_NEW_MESSAGE = "MESSAGES/RECEIVE_NEW_MESSAGE";
export var UPDATE_UNREAD_MESSAGE_COUNT = "MESSAGES/UPDATE_UNREAD_MESSAGE_COUNT";
export var HISTORY_MESSAGES_LOADED = "MESSAGES/HISTORY_MESSAGES_LOADED";
export function getUnreadMessageCountForDisplay(action) {
  var _a;

  assert(action, "action falsy");
  var notMyMessageFromOtherDevice = !action.isFromMyself;
  var notMessageFromCurrentContact = ((_a = action.currentContactChatId) === null || _a === void 0 ? void 0 : _a.encode()) !== action.chatId.encode();
  var isChatRoomStatusOrDataSyncMessage = action.lastMessage && action.lastMessage instanceof RichCustomChatMessageDto && (action.lastMessage.customType === FhtLeancloudCustomMessageType.ChatRoomStatus || action.lastMessage.customType === FhtLeancloudCustomMessageType.DataSync);
  var shouldAddToCount = notMyMessageFromOtherDevice && notMessageFromCurrentContact && !isChatRoomStatusOrDataSyncMessage;
  if (!shouldAddToCount) return 0;
  return action.unreadMessageCount || 0;
}